import Vue from 'vue'
import Router from 'vue-router'

/**
 * 系统管理
 */
// 菜单管理
const SysMenu = () => import('@/components/system/menus/Menus.vue')
// 权限管理
const SysPerm = () => import('@/components/system/perm/Perm.vue')
// 用户管理
const SysUsers = () => import('@/components/user/User.vue')
// 角色管理
const SysRoles = () => import('@/components/role/role.vue')
// 账单配置
const SysBill = () => import('@/components/system/bill/Bill.vue')
// 角色管理
const SysPartner = () => import('@/components/basic/Partner.vue')

/**
 * 基础信息管理
 */
// 仓库管理
const BsStore = () => import('@/components/basic/Store.vue')
// 品牌管理
const BsBrand = () => import('@/components/basic/Brand.vue')
// 店铺管理
const BsShop = () => import('@/components/basic/Shop.vue')
// 平台管理
const BsPlate = () => import('@/components/basic/Plate.vue')
// 模板下载
const BsGetImportTemp = () => import('@/components/basic/Getimporttemp.vue')
// b2b模板配置
const BsGetTemplate = () => import('@/components/basic/GetTemplate.vue')
// 提货管理
const BsWarehouse = () => import('@/components/basic/Warehouse.vue')
// 商家管理
const BsPtnstore = () => import('@/components/basic/Ptnstore.vue')

/**
 * b2b业务管理
 */
// 商品管理（b2b商品管理）
const PrdItems = () => import('@/components/b2b/product/Items.vue')
// 商品管理（b2b套装管理）
const PrdSuit = () => import('@/components/b2b/product/Suit.vue')
// 商品管理（商品更新日志）
const PrrdLogs = () => import('@/components/b2b/product/PrdLog.vue')
// 商品管理（库存变更日志）
const PrrduptLogs = () => import('@/components/b2b/product/PrduptLog')
// 商品管理（商品库存快照）
const PrdStockLogs = () => import('@/components/b2b/product/StockLog.vue')
// 商品管理（商品效期预警）
const PrdWarnLists = () => import('@/components/b2b/product/WarnList.vue')
// 采购管理（供应商管理）
const PrdVendor = () => import('@/components/b2b/Vendor.vue')
// 采购管理（采购单管理）
const PrdPord = () => import('@/components/b2b/Porder.vue')
// 销售管理（配送中心）
const PrdAgent = () => import('@/components/b2b/Agent.vue')
// 销售管理（销售单管理）
const PrdOrder = () => import('@/components/b2b/Order.vue')
// 库存管理（b2b库存管理）
const PrdStkLists = () => import('@/components/b2b/stock/Lists.vue')
// 库存管理（库存冻结）
const PrdFrzLists = () => import('@/components/b2b/stock/FrzLists.vue')
// 库存管理（在途库存）
const PrdTranStock = () => import('@/components/b2b/stock/TranStock.vue')
// 库存管理（入库管理）
const PrdStockIo = () => import('@/components/b2b/stock/Stockio.vue')
// 库存管理（出库管理）
const PrdOutstk = () => import('@/components/b2b/stock/Outstk.vue')
// 库存管理（调拨单管理）
const PrdTransfer = () => import('@/components/b2b/stock/Transfer')
// 库存管理（仓内加工单）
const PrdStoreprocess = () => import('@/components/b2b/stock/Storeprocess')
// 库存管理（库存核对）
const B2Verify = () => import('@/components/b2b/stock/Verify')
// 库存管理（）
// const B2Recon = () => import('@/components/b2b/stock/Recon')
// 库存管理（单据核对）
const PrdDocuVeri = () => import('@/components/b2b/stock/DocuVeri')

/**
 * b2c业务管理
 */
// 订单管理（发货管理）
const DeliverList = () => import('@/components/platform-order/deliver')
// 订单管理（机身码查询）
const B2CodeInqu = () => import('@/components/platform-order/codeinqu')
// 订单管理（平台订单）
const B2PlatOrder = () => import('@/components/platform-order/list')
// 订单管理（退货管理）
const B2ReliverLists = () => import('@/components/platform-order/retordlists/retordlists.vue')
// 订单管理（换货管理）
const B2ChgordLists = () => import('@/components/platform-order/chgordlists/chgordlists.vue')
// 订单管理（异常订单）
const B2ErrordLists = () => import('@/components/platform-order/errordlists/errordlists.vue')
// 订单管理（取消管理）
const B2CancelOrds = () => import('@/components/platform-order/cancelords/cancelords.vue')
// 商品管理（商品主档-店铺）
const B2ShopPrd = () => import('@/components/shopprd')
// 商品管理（商品主档-套餐）
const B2SuitPrd = () => import('@/components/suitprd')
// b2c库存管理（仓内库存调拨）
const B2VirtualInventorys = () => import('@/components/inventory/iv/index.vue')
// 商品管理（商品主档-商家）
const B2Prditemlist = () => import('@/components/prditemlist')
// 商品管理（平台商品管理）
const B2Platprd = () => import('@/components/platprd')
// b2c库存管理（库存列表）
const B2InventoryList = () => import('@/components/inventory/list')
// b2c库存管理（库存核对）
const B2InventoryVerify = () => import('@/components/inventory/verify/verify.vue')
// b2c库存管理（销量预测）
const B2Pred = () => import('@/components/inventory/pred')
// b2c库存管理（超保仓汇总）
const B2Waresum = () => import('@/components/inventory/waresum')
// b2c库存管理（入库管理）
const B2InventoryIn = () => import('@/components/inventory/in')
// b2c库存管理（出库管理）
const B2InventoryOut = () => import('@/components/inventory/out')
// b2c库存管理（日志管理）
// const B2InventoryLog = () => import('@/components/inventory/log')
// b2c库存管理（）
// const B2InventoryIO = () => import('@/components/inventory/io')

/**
 * 抖音区块
 */
// 商品管理
const DyProductMag = () => import('@/components/dy/productMag')
// 批量优化
const DyBatchOptimiz = () => import('@/components/dy/batchOptimiz')

/**
 * 运营管理
 */
// 运营管理（物流设置）
const OpExpLists = () => import('@/components/operator/explists/explists.vue')
// 运营管理（队列管理）
const OpJobLists = () => import('@/components/operator/joblists/joblists.vue')
// 运营管理（订单锁定）
const OpLockLists = () => import('@/components/operator/locklists/locklists.vue')
// 运营管理（安全库存配置）
const OpSafStkLists = () => import('@/components/operator/safstklists/safstklists.vue')
// 数据报表（复购管理）
const OpReprchseLists = () => import('@/components/operator/reprchse/index.vue')
// 运营管理（自动审单）
const OpOrderAuto = () => import('@/components/operator/orderauto/orderauto.vue')
// 运营管理（订单合并）
const OpOrderMerge = () => import('@/components/orderMerge')
// 运营管理（订单拆分）
const OpOrderSpite = () => import('@/components/orderSpite')
// 运营管理（赠品设置）
const OpGiftLists = () => import('@/components/operator/gift-list')
// 运营管理（发货仓设置）
const OpStkSet = () => import('@/components/stk-set')
// 运营管理（赠品管理）
// const OpGiftMag = () => import('@/components/operator/giftmag')
// 运营管理（预售设置）
const OpPresales = () => import('@/components/operator/presales')

/**
 * 数据报表
 */
// 数据报表（虚拟库存汇总）
const ReVitInvSum = () => import('@/components/data-report/vitInvSum')
// 数据报表（库存报表）
const DtInvtReport = () => import('@/components/data-report/invtReport')
// 数据报表（财务对账）
const DtFinRecon = () => import('@/components/data-report/finRecon')
// 数据报表（对账单）
const DtStatacount = () => import('@/components/data-report/statacount')
// 数据报表（订单销售统计表）
const DtOrderstatistics = () => import('@/components/data-report/orderStatistics')
// 数据报表（订单销售统计（单品）表）
const DtOrderSgleStatistics = () => import('@/components/data-report/orderSgleStatistics')
// 数据报表（运营报表）
const DtOrderOperat = () => import('@/components/data-report/orderOperat')
// 数据报表（）
// const DtGmvReport = () => import('@/components/data-report/gmvReport')
// 数据报表（）
// const DtGmvPlan = () => import('@/components/data-report/gmvPlan')
// 数据报表（）
// const DtB2bReport = () => import('@/components/data-report/b2bReport')
// 数据报表（）
// const DtInventoryData = () => import('@/components/data-report/Inventory')
// 数据报表（）
// const DtFlowlys = () => import('@/components/data-report/flowlys')
// 数据报表（）
// const DtInvenfin = () => import('@/components/data-report/invenfin')
// 数据报表（）
// const DtInvenorv = () => import('@/components/data-report/invenorv')

/**
 * 财务对账
 */
// 财务对账（收支分类设置）
const FiClasificSet = () => import('@/components/financRecon/clasificSet')
// 财务对账（费用项设置）
const FiCostitemSet = () => import('@/components/financRecon/costitemSet')
// 财务对账（核销规则设置）
const FiWritrulSet = () => import('@/components/financRecon/writrulSet')
// 财务对账（api列表设置）
const FiDocSet = () => import('@/components/financRecon/docSet')
// 财务对账（平台账单）
const FiPlatformBills = () => import('@/components/financRecon/platformBills')
// 财务对账（收支分类）
const FiIeCategory = () => import('@/components/financRecon/ieCategory')
// 财务对账（账期设置）
const FiBillingPeriod = () => import('@/components/financRecon/billingPeriod')
// 财务对账（对账设置）
const FiReconSetting = () => import('@/components/financRecon/reconSetting')
const FiCategoryMapping = () => import('@/components/financRecon/categoryMapping')
// 财务对账（差异调整单）
const FiDiffAdjustment = () => import('@/components/financRecon/diffAdjustment')
// 财务对账（订单费用明细）
const FiOrderFeeDetails = () => import('@/components/financRecon/orderFeeDetails')
// 财务对账（对账单）
const FiReconciliation = () => import('@/components/financRecon/reconciliation')
// 财务对账（店铺毛利表）
const FiShopGrossProfit = () => import('@/components/financRecon/shopGrossProfit')
const FiInvoicePending = () => import('@/components/financRecon/invoicePending')
const FiInvoiceRecords = () => import('@/components/financRecon/invoiceRecords')
const FiImportExportLogs = () => import('@/components/financRecon/importExportLogs')
const FiReceivableRefund = () => import('@/components/financRecon/receivableRefund')
const FiActualReceipt = () => import('@/components/financRecon/actualReceipt')

/**
 * 接口管理
 */
// 接口管理（应用管理）
const InterfApplication = () => import("@/components/interface/application.vue");
// 接口管理（接口列表）
const InterfList = () => import("@/components/interface/list.vue");

/**
 * 其他
 */
// 登录
const Login = () => import('@/components/Login.vue')
// 首页
const Home = () => import('@/components/Home.vue')
// 工作台
const Welcome = () => import('@/components/Welcome.vue')
// 404
const NotFind = () => import('@/components/not-find')

// const OrdSet = () => import('@/components/ordset')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', name: 'login', component: Login },
    {
      path: '/home',
      name: 'home',
      component: Home,
      redirect: '/welcome',
      children: [
        // 系统管理
        { path: '/welcome', name: 'welcome', component: Welcome },
        { path: '/menus', name: 'menus', component: SysMenu },
        { path: '/perm', name: 'perm', component: SysPerm },
        { path: '/users', name: 'users', component: SysUsers },
        { path: '/roles', name: 'roles', component: SysRoles },
        { path: '/bill', name: 'bill', component: SysBill },
        { path: '/partner', name: 'partner', component: SysPartner },

        // 基础信息管理
        { path: '/store', name: 'store', component: BsStore },
        { path: '/brand', name: 'brand', component: BsBrand },
        { path: '/shop', name: 'shop', component: BsShop },
        { path: '/plate', name: 'plate', component: BsPlate },
        { path: '/getImportTemp', name: 'getImportTemp', component: BsGetImportTemp },
        { path: '/getTemplate', name: 'getTemplate', component: BsGetTemplate },
        { path: '/warehouse', name: 'warehouse', component: BsWarehouse },
        { path: '/ptnstore', name: 'ptnstore', component: BsPtnstore },

        // b2b业务管理
        { path: '/b2bitems', name: 'b2bitems', component: PrdItems },
        { path: '/b2bcomblists', name: 'b2bcomblists', component: PrdSuit },
        { path: '/b2bprdlogs', name: 'b2bprdlogs', component: PrrdLogs },
        { path: '/b2bprduptlogs', name: 'b2bprduptlogs', component: PrrduptLogs },
        { path: '/b2bstocklogs', name: 'b2bstocklogs', component: PrdStockLogs },
        { path: '/b2bwarnlists', name: 'b2bwarnlists', component: PrdWarnLists },
        { path: '/b2bvdr', name: 'b2bvdr', component: PrdVendor },
        { path: '/b2bord', name: 'b2bord', component: PrdPord },
        { path: '/b2bagent', name: 'b2bagent', component: PrdAgent },
        { path: '/b2bsale', name: 'b2bsale', component: PrdOrder },
        { path: '/b2bstore', name: 'b2bstore', component: PrdStkLists },
        { path: '/frozenLists', name: 'frozenLists', component: PrdFrzLists },
        { path: '/b2btranstock', name: 'b2btranstock', component: PrdTranStock },
        { path: '/b2binstk', name: 'b2binstk', component: PrdStockIo },
        { path: '/b2boutstk', name: 'b2boutstk', component: PrdOutstk },
        { path: '/b2btransfer', name: 'b2btransfer', component: PrdTransfer },
        { path: '/b2bstoreprocess', name: 'b2bstoreprocess', component: PrdStoreprocess },
        { path: '/b2bverify', name: 'b2bverify', component: B2Verify },
        // { path: '/b2brecon', name: 'b2brecon', component: B2Recon },
        { path: '/b2bdocuveri', name: 'b2bdocuveri', component: PrdDocuVeri },

        // b2c业务管理
        { path: '/orderLists', name: 'orderLists', component: DeliverList },
        { path: '/sendbidlists', name: 'sendbidlists', component: B2CodeInqu },
        { path: '/platorders', name: 'platorders', component: B2PlatOrder },
        { path: '/retordlists', name: 'reliverLists', component: B2ReliverLists },
        { path: '/chgordlists', name: 'chgordLists', component: B2ChgordLists },
        { path: '/errordlists', name: 'errordLists', component: B2ErrordLists },
        { path: '/cancelOrds', name: 'cancelOrds', component: B2CancelOrds },
        { path: '/shopprd', name: 'shopPrd', component: B2ShopPrd },
        { path: '/combLists', name: 'combLists', component: B2SuitPrd },
        { path: '/virtualInventorys', name: 'virtualInventorys', component: B2VirtualInventorys },
        { path: '/prditemlist', name: 'prditemlist', component: B2Prditemlist },
        { path: '/platprd', name: 'plat', component: B2Platprd },
        { path: '/inventoryList', name: 'inventoryList', component: B2InventoryList },
        { path: '/inventoryVerify', name: 'inventoryVerify', component: B2InventoryVerify },
        { path: '/pred', name: 'pred', component: B2Pred },
        { path: '/osizeWare', name: 'osizeWare', component: B2Waresum },
        { path: '/inventoryIn', name: 'inventoryIn', component: B2InventoryIn },
        { path: '/inventoryOut', name: 'inventoryOut', component: B2InventoryOut },
        // { path: '/inventoryLog', name: 'inventoryLog', component: B2InventoryLog },
        // { path: "/inventoryIO", name: "inventoryIO", component: B2InventoryIO },

        // 抖音区块
        { path: "/productMag", name: "productMag", component: DyProductMag },
        { path: "/batchOptimiz", name: "batchOptimiz", component: DyBatchOptimiz },

        // 运营管理
        { path: '/explists', name: 'expLists', component: OpExpLists },
        { path: '/joblists', name: 'jobLists', component: OpJobLists },
        { path: '/lockLists', name: 'lockLists', component: OpLockLists },
        { path: '/safeStks', name: 'safStkLists', component: OpSafStkLists },
        { path: '/reprchse', name: 'reprchseLists', component: OpReprchseLists },
        { path: '/orderauto', name: 'orderAuto', component: OpOrderAuto },
        { path: '/orderMerge', name: 'orderMerge', component: OpOrderMerge },
        { path: '/orderSpite', name: 'orderSpite', component: OpOrderSpite },
        { path: '/giftLists', name: 'giftLists', component: OpGiftLists },
        { path: '/stockSetLists', name: 'stockSetLists', component: OpStkSet },
        // { path: '/giftMag', name: 'giftMag', component: OpGiftMag },
        { path: '/presales', name: 'presales', component: OpPresales },

        // 数据报表
        { path: '/vitInvSum', name: 'vitInvSum', component: ReVitInvSum },
        { path: '/invtReport', name: 'invtReport', component: DtInvtReport },
        { path: '/finRecon', name: 'finRecon', component: DtFinRecon },
        { path: '/statacount', name: 'statacount', component: DtStatacount },
        { path: '/exportTbSalesStatList', name: 'exportTbSalesStatList', component: DtOrderstatistics },
        { path: '/exportTbSalesItemStatList', name: 'exportTbSalesItemStatList', component: DtOrderSgleStatistics },
        { path: '/exportTbOperationStatList', name: 'exportTbOperationStatList', component: DtOrderOperat },
        // { path: '/gmvreport', name: 'gmvreport', component: DtGmvReport },
        // { path: '/gmvplan', name: 'gmvplan', component: DtGmvPlan },
        // { path: '/b2breport', name: 'b2breport', component: DtB2bReport },
        // { path: '/inventoryData', name: 'inventoryData', component: DtInventoryData },
        // { path: '/flowlys', name: 'flowlys', component: DtFlowlys },
        // { path: '/invenfin', name: 'invenfin', component: DtInvenfin },
        // { path: '/welcome2', name: 'invenorv', component: DtInvenorv },

        // 财务对账
        { path: '/clasificSet', name: 'clasificSet', component: FiClasificSet },
        { path: '/ieCategory', name: 'ieCategory', component: FiIeCategory },
        { path: '/costitemSet', name: 'costitemSet', component: FiCostitemSet },
        { path: '/writrulSet', name: 'writrulSet', component: FiWritrulSet },
        { path: '/docSet', name: 'docSet', component: FiDocSet },
        { path: '/platformBillLists', name: 'platformBillLists', component: FiPlatformBills },
        { path: '/billingPeriod', name: 'billingPeriod', component: FiBillingPeriod },
        { path: '/reconSetting', name: 'reconSetting', component: FiReconSetting },
        { path: '/categoryMapping', name: 'categoryMapping', component: FiCategoryMapping },
        { path: '/diffAdjustment', name: 'diffAdjustment', component: FiDiffAdjustment },
        { path: '/orderFeeDetails', name: 'orderFeeDetails', component: FiOrderFeeDetails },
        { path: '/reconciliation', name: 'reconciliation', component: FiReconciliation },
        { path: '/shopGrossProfit', name: 'shopGrossProfit', component: FiShopGrossProfit },
        { path: '/invoicePending', name: 'invoicePending', component: FiInvoicePending },
        { path: '/invoiceRecords', name: 'invoiceRecords', component: FiInvoiceRecords },
        { path: '/importExportLogs', name: 'importExportLogs', component: FiImportExportLogs },
        { path: '/receivableRefund', name: 'receivableRefund', component: FiReceivableRefund },
        { path: '/actualReceipt', name: 'actualReceipt', component: FiActualReceipt },

        // 接口管理
        { path: "/interfApplication", name: "interfApplication", component: InterfApplication },
        { path: "/interfList", name: "interfList", component: InterfList },

        { path: "/aftersaleCate", name: "aftersaleCate", component: ()=>import('@/components/aftersale/CateSet.vue') },
      ]
    },
    { path: '*', component: NotFind }
  ]
})
/**
 * 路由守卫控制页面访问
 * @params to 将要访问的页面
 * @params from 从哪个页面来
 * @params next  放行
 */
router.beforeEach((to, from, next) => {
  const tokenStr = window.sessionStorage.getItem('token')
  // if (to.path === '/login') {
  //   if (tokenStr) {
  //     var activePath = window.sessionStorage.getItem('activePath')
  //     if (activePath == 'null' || !activePath) {
  //       activePath = '/home'
  //       location.reload()
  //       // return this.$router.push()
  //     }
  //     return next(activePath)
  //   } else {
  //     return next()
  //   }
  // }

  // const tokenStr = window.sessionStorage.getItem('token')
  // if (!tokenStr) {
  //   return next('/login') // 强制跳转
  // }

  // next()

  if (tokenStr) {
    // 已登录
    let activePath = window.sessionStorage.getItem('activePath')

    if (activePath == 'null' || !activePath || activePath == '/docSet') {
      activePath = '/home'
      // location.reload()
    }

    if(to.query.sign) {
      let tful = to.fullPath
      window.sessionStorage.clear()
      next('/login'+tful.substring(tful.indexOf('?')))
    } else if (to.path === '/login' || to.path === '/docSet') {
      return next(activePath)
    } else {
      next()
    }
  } else {
    // 未登录
    const whiteList = ['/login', '/']
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js